import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';

export { AgGridAurelia } from './src/ag-grid-aurelia';
export { AgGridColumn } from './src/ag-grid-column';
export { AgCellTemplate } from './src/ag-template';
export { AgEditorTemplate } from './src/ag-template';
export { AgFullWidthRowTemplate } from './src/ag-template';
export { AgFilterTemplate } from './src/ag-template';

export function configure(config: FrameworkConfiguration) {
  config.globalResources([
    PLATFORM.moduleName('./src/ag-grid-aurelia'),
    PLATFORM.moduleName('./src/ag-grid-column'),
    PLATFORM.moduleName('./src/ag-template'),
    PLATFORM.moduleName('../elements/grid-columns-button/grid-columns-button')
  ]);
}
